import {remCalc} from '_themeUtils'

const localeModal = {
    LocaleModal: {
        baseStyle: () => ({
            picture_wrap: {
                w: {base: '100%', md: remCalc(716), lg: remCalc(874)},
                h: {base: remCalc(150), md: remCalc(331), lg: remCalc(346)},
                direction: 'column',
            },
            wrapper: {
                direction: 'column',
                pos: 'relative',
                w: {base: `calc( 100% - ${remCalc(30)})`},
                maxW: `${remCalc(421)}`,
                m: '0 auto',
                pb: 'spacing.10',
                mt: {base: `-spacing.24`},
                background: 'color.background.white',
                p: {base: 'unset', md: `0 0 ${remCalc(40)} 0`},
            },
            description: {
                w: '100%',
                textAlign: 'center',
                p: {base: `0 ${remCalc(10)}  ${remCalc(16)}`, md: `${remCalc(16)} ${remCalc(28)}`},
                letterSpacing: remCalc(0.6),
                textStyle: {base: 'paragraphSm', md: 'paragraphMd'},
                lineHeight: {base: 'spacing.5', md: 'spacing.6'},
            },
            title: {
                textStyle: {base: 'paragraphXl', md: 'displayXs'},
                textAlign: 'center',
                fontWeight: 500,
                letterSpacing: remCalc(1),
                lineHeight: {base: 'spacing.8', md: 'spacing.9'},
                p: {base: 'spacing.2', md: `${remCalc(48)} ${remCalc(112)} 0 ${remCalc(112)}`},
            },
            wrapperSelect: {
                p: {base: `0 ${remCalc(10)}`, md: `${remCalc(16)} 0 0 0`},
                '.select__label': {
                    pl: {base: 0, md: 'spacing.3' },
                    pb: {base: remCalc(14), md: 'spacing.1'},
                }
            },
            button: {
                alignSelf: 'center',
                textTransform: 'uppercase',
                mb: {base: `${remCalc(16)}`, md: 'unset'},
                w: {base: '100%', md: `${remCalc(196)}`},
            },
            sizes: {
                md: {
                    wrapper: {
                        w: {base: `calc( 100% - ${remCalc(30)})`},
                    },
                },
            },
        }),
    },
}

export default localeModal
